import HcAccordion from "./HcAccordion/HcAccordion";
import HcCta from "./HcCta/HcCta";
import HcGrid from "./HcGrid/HcGrid";
import HcHeadline from "./HcHeadline/HcHeadline";
import HcHighlight from "./HcHighlight/HcHighlight";
import HcSteps from "./HcSteps/HcSteps";
import HcHero from "./HcHero/HcHero";
import HcUl from "./HcUl/HcUl";
import MegaMenu from "./MegaMenu/MegaMenu";
import ParallelHighlights from "./ParallelHighlights/ParallelHighlights";
import StructureFilter from "./StructureFilter/StructureFilter";

export default {
  StructureFilter,
  MegaMenu,
  ParallelHighlights,
  HcHighlight,
  HcSteps,
  HcHero,
  HcAccordion,
  HcUl,
  HcHeadline,
  HcGrid,
  HcCta,
};
